import Model, { attr } from '@ember-data/model';

export default class UploadFileModel extends Model {
  @attr('string') label!: string;
  @attr('string') key!: string;
  @attr('string') bucket!: string;
  @attr('string') accessKey!: string;
  @attr('string') policy!: string;
  @attr('string') signature!: string;
  @attr('boolean') required!: boolean;
  @attr('string') processArgKey!: string;
  @attr('boolean') processArgIsArray!: boolean;

  // upload-file-item sets this to true when the user has selected a file from
  // their computer
  @attr('boolean') fileChosen?: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'admin/upload-file': UploadFileModel;
  }
}
